import { Injectable } from '@angular/core';
import { CadastroGenericoService } from 'src/app/services/cad/cadastro-generico.service';

@Injectable({
  providedIn: 'root'
})
export class TransformService {

  constructor(public service: CadastroGenericoService) { }

  convertNumberToTimeString(decimal: number) {
    const horas = Math.floor(decimal);
    const minutos = Math.round((decimal - horas) * 60);
    return this.convertMinutesToTimeString(horas * 60 + minutos);
  }

  convertTimeStringToHours(time: string) {
    let hoursMin:string[] = [];
    if(time && time.includes(':')) {
      hoursMin = time.split(':');
    }else{
      hoursMin[1] = time.substring(time.length - 2);
      hoursMin[0] = time.substring(0, time.length - 2);
    }
    return (parseFloat(hoursMin[0]) + (parseFloat(hoursMin[1]) / 60) );
  }

  convertTimeStringToMinutes(time: string | number) {
    this.service.listarTodos();
    const hoursMin = time.toString().split(':');
    return (parseInt(hoursMin[0]) * 60 + parseInt(hoursMin[1]));
  }

  convertMinutesToTimeString(minutes: string | number) {
    let isNegative: boolean = false;
    if (minutes) {
      if (typeof minutes == "string") {
        minutes = parseFloat(minutes);
      }
      if (minutes < 0) {
        isNegative = true;
        minutes = Math.abs(minutes);
      }
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      // Formatar com zeros à esquerda, se necessário
      const formattedHours = hours.toString().padStart(4, '0');
      const formattedMinutes = remainingMinutes.toString().padStart(2, '0');

      return isNegative ? `-${formattedHours}:${formattedMinutes}` : `${formattedHours}:${formattedMinutes}`
    } else {
      return '0000:00';
    }
  }

  convertDateTimeToString(dateString, hasTime = false) {
    const date = new Date(dateString);

    if (!hasTime) {
      date.setHours(date.getHours() + 3); // Correção de fuso horário
    }

    const dia = date.getDate().toString(),
      diaF = (dia.length == 1) ? '0' + dia : dia,
      mes = (date.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length == 1) ? '0' + mes : mes,
      anoF = date.getFullYear();

    if (hasTime) {
      const hora = date.getHours();
      const horaF = hora < 10 ? `0${hora}` : hora;
      const minutos = date.getMinutes();
      const minutosF = minutos < 10 ? `0${minutos}` : minutos;
      return `${diaF}/${mesF}/${anoF} ${horaF}:${minutosF}`;
    } else {
      return `${diaF}/${mesF}/${anoF}`;
    }
  }
}
